module.exports = __webpack_public_path__ + "img/Unidad5-2.218a2f64.png";